import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import GShell from './GShell.jsx'
import { Title, Card, Field, Err } from './gui.jsx'
import { ROLES } from '../../lib/roles.js'
import { watchSettings, updateSettings } from '../../lib/settings.js'

// Settings — tax, taxonomy lists, notification templates, permissions info.
export default function GSettings() {
  const [s, setS] = useState(null)
  const [flash, setFlash] = useState('')
  const [err, setErr] = useState('')
  useEffect(() => { const off = watchSettings(setS); return () => off() }, [])
  if (!s) return <GShell><p className="text-sm text-gray-500">Loading…</p></GShell>

  const saveList = async (key, str) => { try { await updateSettings({ [key]: str.split(',').map((x) => x.trim()).filter(Boolean) }); ping() } catch (e) { setErr(e?.message || 'Failed') } }
  const saveVal = async (key, val) => { try { await updateSettings({ [key]: val }); ping() } catch (e) { setErr(e?.message || 'Failed') } }
  const saveTemplate = async (k, val) => { try { await updateSettings({ [`notificationTemplates/${k}`]: val }); ping() } catch (e) { setErr(e?.message || 'Failed') } }
  const ping = () => { setFlash('Saved ✓'); setTimeout(() => setFlash(''), 1500) }

  return (
    <GShell>
      <Title title="Settings" subtitle="Tax, taxonomy, notification templates, permissions." right={flash ? <span className="text-xs font-bold" style={{ color: '#15803D' }}>{flash}</span> : null} />

      <Card>
        <div className="text-xs font-extrabold uppercase tracking-widest mb-2" style={{ color: 'var(--ge-primary)' }}>Tax</div>
        <Field label="Sales tax rate (%)"><input className="input w-40" type="number" step="0.001" defaultValue={s.taxRate} onBlur={(e) => saveVal('taxRate', Number(e.target.value) || 0)} /></Field>
        <p className="text-[11px] text-gray-400 mt-1">Applied at POS. Blur to save.</p>
      </Card>

      <div className="grid md:grid-cols-3 gap-3">
        <ListCard label="Departments" value={(s.departments || []).join(', ')} onSave={(v) => saveList('departments', v)} />
        <ListCard label="Categories" value={(s.categories || []).join(', ')} onSave={(v) => saveList('categories', v)} />
        <ListCard label="Brands" value={(s.brands || []).join(', ')} onSave={(v) => saveList('brands', v)} />
      </div>

      <Card>
        <div className="text-xs font-extrabold uppercase tracking-widest mb-2" style={{ color: 'var(--ge-primary)' }}>Notification templates</div>
        {[['orderIn', 'Order arrived'], ['repairReady', 'Repair ready'], ['demoOverdue', 'Demo overdue']].map(([k, lbl]) => (
          <Field key={k} label={lbl}><input className="input w-full" defaultValue={s.notificationTemplates?.[k] || ''} onBlur={(e) => saveTemplate(k, e.target.value)} /></Field>
        ))}
        <p className="text-[11px] text-gray-400 mt-1">Use [name] for the member's first name. Provider hookup pending — messages are copy-to-send today.</p>
      </Card>

      <Card>
        <div className="text-xs font-extrabold uppercase tracking-widest mb-2" style={{ color: 'var(--ge-primary)' }}>Permissions (roles)</div>
        <p className="text-sm text-gray-600">Roles rank <b>{ROLES.join(' < ')}</b>. Manager+ can add/edit employees; owner can delete. Set "acting as" in <Link to="/admin/gg/employees" className="underline" style={{ color: 'var(--ge-primary)' }}>Employees</Link>.</p>
      </Card>

      <Card>
        <div className="text-xs font-extrabold uppercase tracking-widest mb-2" style={{ color: 'var(--ge-primary)' }}>Vendors</div>
        <p className="text-sm text-gray-600">Manage suppliers in the <Link to="/admin/gg/vendors" className="underline" style={{ color: 'var(--ge-primary)' }}>Vendors</Link> module.</p>
      </Card>
      <Err msg={err} />
    </GShell>
  )
}

function ListCard({ label, value, onSave }) {
  return (
    <Card>
      <div className="text-xs font-extrabold uppercase tracking-widest mb-1" style={{ color: 'var(--ge-primary)' }}>{label}</div>
      <textarea className="input w-full text-sm" rows={3} defaultValue={value} onBlur={(e) => onSave(e.target.value)} />
      <p className="text-[10px] text-gray-400">Comma-separated. Blur to save.</p>
    </Card>
  )
}
